import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Faded } from "baby-i-am-faded";
import clsx from "clsx";
import { PageContainer } from "../landing";
export function FeaturesBlocks(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, features = param.features, _className = param.className, className = _className === void 0 ? "" : _className, _blocksClassName = param.blocksClassName, blocksClassName = _blocksClassName === void 0 ? "" : _blocksClassName;
    return /*#__PURE__*/ _jsx(PageContainer, {
        className: className,
        style: style,
        children: /*#__PURE__*/ _jsx("div", {
            className: "py-12",
            children: /*#__PURE__*/ _jsx(Faded, {
                delay: 500,
                cascade: true,
                className: clsx("justify-center grid gap-12 xl:grid-cols-3 xl:gap-28", "sm:grid-cols-2 md:justify-start md:gap-16"),
                children: features.map(function(feature, i) {
                    return /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex space-x-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: clsx("w-14 shadow-lg rounded-lg opacity-90", "justify-center items-center h-14 flex-shrink-0", "flex md:rounded-xl", blocksClassName),
                                    children: feature.Icon && /*#__PURE__*/ _jsx(feature.Icon, {
                                        className: "w-6 font-bold h-6"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "space-y-1",
                                    children: [
                                        feature.bullet && /*#__PURE__*/ _jsx("div", {
                                            className: clsx("tracking-wider rounded px-1 mb-1 max-w-max", "font-semibold dark:bg-gray-800 bg-gray-100 text-[10px]", "py-[2px] -mt-[2.1em]"),
                                            children: feature.bullet
                                        }),
                                        /*#__PURE__*/ _jsx("h3", {
                                            className: "text-lg font-semibold md:text-xl",
                                            children: feature.heading
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-sm opacity-60",
                                            children: feature.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, i);
                })
            })
        })
    });
}
